// extracted by mini-css-extract-plugin
export default {"content":"eCP1ozFKtiE87yuiwxzs"};